import { stringify } from 'qs';

import { DOMAINS } from '../constants';

// @see https://stackoverflow.com/a/34773221
const hasExtension = (url: string) =>
  url.match(/\[\.#]([0-9a-z]+)(?=[?#])|([.#])(?:[\w]+)$/gi);

const addTrailingSlash = (url: string) => url.replace(/\/$|$/, '/');

const isTruthy = (i: string | null | undefined): i is string => Boolean(i);

const isNotHomepage = (segment: string) => {
  const domainHomepages = Object.values(DOMAINS).map((domain) =>
    domain.homepagePath?.replace('/', ''),
  );
  return !domainHomepages.includes(segment);
};

const stripSlashes = (segment: string, index: number) => {
  if (index === 0) {
    return segment.replace(/^\/{2,}/g, '/').replace(/\/+$/g, '');
  }

  return segment.replace(/^\/+|\/+$/g, '');
};

/**
 * This function is for building URLs with query parameters.
 *
 * @param segments
 *  The segments of the URL to build.
 * @param query
 *  The query parameters to add to the URL.
 * @param queryOptions
 *  The options to pass to `qs.stringify`.
 */
export const buildUrl = (
  segments: Array<string | null | undefined>,
  query?: Parameters<typeof stringify>[0],
  queryOptions?: Parameters<typeof stringify>[1],
) => {
  const sanitizedUrl = segments
    .filter(isTruthy)
    .map(stripSlashes)
    .filter(isNotHomepage)
    .join('/');

  const [url, queryFromUrl] = sanitizedUrl.split('?');

  const queryString = stringify(query, {
    skipNulls: true,
    ...queryOptions,
  });

  return [
    hasExtension(url) ? url : addTrailingSlash(url),
    queryString || queryFromUrl,
  ]
    .filter(isTruthy)
    .join('?');
};
